import v from "@/lib/validator";
import { TFunction } from "i18next";

const RegisterResourceSchema = (translate: TFunction) => {
    const requiredValidation = v.methods().required({message: translate('resourcesForm.inputs.errorsMessages.required')})
  return v.object({
    nomeRecurso: requiredValidation,
    tipoRecurso: requiredValidation
  });
};

export default RegisterResourceSchema;
